import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHashHistory } from 'vue-router'

import Dashboard from '../views/Dashboard.vue'
// import Forms from '../views/Forms.vue'
// import Tables from '../views/Tables.vue'
// import UIElements from '../views/UIElements.vue'
import Login from '../views/Login.vue'
// import Modal from '../views/Modal.vue'
// import Card from '../views/Card.vue'
// import Blank from '../views/Blank.vue'
import ContactAnalyze from '../views/ContactAnalyze.vue'
import TreatmentSchedule from '../views/TreatmentSchedule.vue'
import LazyTreatmentSchedule from '../views/LazyTreatmentSchedule.vue'
import LazyContactAnalyze from '../views/LazyContactAnalyze.vue'


const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { layout: 'empty' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/:phone/analyze',
    name: 'ContactAnalysis',
    component: ContactAnalyze,
    props: true,
    meta: { layout: 'empty' },
  },
  {
    path: '/:phone/schedule',
    name: 'PatientScheduling',
    component: TreatmentSchedule,
    props: true,
    meta: { layout: 'empty' },
  },
  {
    path: '/:phone/schedule',
    name: 'PatientSchedulingChatwoot',
    component: LazyTreatmentSchedule,
    props: true,
    meta: { layout: 'empty' },
  },
  {
    path: '/analyze',
    name: 'ContactAnalysisChatwoot',
    component: LazyContactAnalyze,
    meta: { layout: 'empty' },
  },
  // {
  //   path: '/forms',
  //   name: 'Forms',
  //   component: Forms,
  // },
  // {
  //   path: '/cards',
  //   name: 'Cards',
  //   component: Card,
  // },
  // {
  //   path: '/tables',
  //   name: 'Tables',
  //   component: Tables,
  // },
  // {
  //   path: '/ui-elements',
  //   name: 'UIElements',
  //   component: UIElements,
  // },
  // {
  //   path: '/modal',
  //   name: 'Modal',
  //   component: Modal,
  // },
  // {
  //   path: '/blank',
  //   name: 'Blank',
  //   component: Blank,
  // },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
